import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CommsOptInHomeCardQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CommsOptInHomeCardQuery = { __typename?: 'Query', CommsOptIn?: { __typename?: 'CommsOptIn', id: string, status: Types.CommsOptInStatus, launchType?: Types.CommsOptInLaunchType | null, launchAt?: string | null } | null, Me?: { __typename?: 'Me', user: { __typename?: 'Employee', id: number, org?: { __typename?: 'Org', id: number, timezone: Types.Timezone } | null } } | null };


export const CommsOptInHomeCardDocument = gql`
    query CommsOptInHomeCard {
  CommsOptIn {
    id
    status
    launchType
    launchAt
  }
  Me {
    user {
      id
      org {
        id
        timezone
      }
    }
  }
}
    `;

/**
 * __useCommsOptInHomeCardQuery__
 *
 * To run a query within a React component, call `useCommsOptInHomeCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommsOptInHomeCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommsOptInHomeCardQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommsOptInHomeCardQuery(baseOptions?: Apollo.QueryHookOptions<CommsOptInHomeCardQuery, CommsOptInHomeCardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommsOptInHomeCardQuery, CommsOptInHomeCardQueryVariables>(CommsOptInHomeCardDocument, options);
      }
export function useCommsOptInHomeCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommsOptInHomeCardQuery, CommsOptInHomeCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommsOptInHomeCardQuery, CommsOptInHomeCardQueryVariables>(CommsOptInHomeCardDocument, options);
        }
export type CommsOptInHomeCardQueryHookResult = ReturnType<typeof useCommsOptInHomeCardQuery>;
export type CommsOptInHomeCardLazyQueryHookResult = ReturnType<typeof useCommsOptInHomeCardLazyQuery>;
export type CommsOptInHomeCardQueryResult = Apollo.QueryResult<CommsOptInHomeCardQuery, CommsOptInHomeCardQueryVariables>;